import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  loadMvpTrainingRequest: null,
  loadMvpTrainingSuccess: ['mvpTrainingData'],
  loadMvpTrainingFailure: ['error'],

  loadSessionsNewRequest: ['data'],
  loadSessionsNewSuccess: ['sessions'],
  loadSessionsNewFailure: ['error'],

  loadUserPackagesRequest: ['caId'],
  loadUserPackagesSuccess: ['userPackages'],
  loadUserPackagesFailure: ['error'],

  loadNotificationRequest: ['userId'],
  loadNotificationSuccess: ['notification'],
  loadNotificationFailure: ['error'],

  updateNotificationRequest: ['data'],
  updateNotificationSuccess: ['updatedNotification'],
  updateNotificationFailure: ['error'],

  loadQRCodeRequest: ['caId'],
  loadQRCodeSuccess: ['qrCodeDetails'],
  loadQRCodeFailure: ['error'],
});

const Actions = {
  Types,
  Creators,
};

export default Actions;
